module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/land-purchase/land-pur-agreements/lp-agreement-grid/lp-agreement-grid.component.css
// module id = ./src/app/landprocurement/land-purchase/land-pur-agreements/lp-agreement-grid/lp-agreement-grid.component.css
// module chunks = main